var ModalCheckRows = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
              m("span.pull-right[style='cursor: pointer;']", {
                onclick: ModalContainerCheckRows.close
              }, [
                m("i.glyphicon.glyphicon-remove"),
                m.trust('&nbsp;Закрыть')
              ])
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Максимально допустимое количество заполненных строк превышено"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        onclick: function () {
                          ModalContainerCheckRows.close();
                        }
                      }, "Ок")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerCheckRows = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerCheckRows.container = document.querySelector('#ModalCheckRows');
    if (!ModalContainerCheckRows.container) {
      ModalContainerCheckRows.container = document.createElement('div');
      ModalContainerCheckRows.container.id = 'ModalCheckRows';
      ModalContainerCheckRows.container.hidden = true;
      document.body.appendChild(ModalContainerCheckRows.container);
      m.mount(ModalContainerCheckRows.container, m.component(ModalCheckRows, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (title, message, buttons= null, idElement = null) {
    ModalContainerCheckRows.container = document.querySelector('#ModalCheckRows');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerCheckRows.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerCheckRows.removeAll = removeAll;
    if (ModalContainerCheckRows.container) {
      // if(title){
      // document.getElementById("modalTitleLmc").innerHTML = title;
      // }
      // if(message){
      // document.getElementById("modalContentLmc").innerHTML = message;
      // }
      /*if(buttons){
          document.getElementById("modalButtons").innerHTML = "";
          document.getElementById("modalButtons").append(buttons);
      }*/


      ModalContainerCheckRows.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerCheckRows.container.hidden = true;
  }
};
